<template>
  <SlideUp v-model:open="isOpen" heading="Your Shopping Cart Is Full">
    <template #content>
      <p>{{ message }}</p>
    </template>
  </SlideUp>
</template>

<script>
import SlideUp from "@/components/SlideUp.vue";

export default {
  name: "BagFailure",
  components: {
    SlideUp,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  emits: ["update:open", "editVariant"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(value) {
        return this.$emit("update:open", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
}
</style>
